module.exports = __webpack_public_path__ + "static/media/gallery2.5376cbbd.jpg";